import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    wallet: null,
    COMMUNITY: [
      { icon: 'telegram', name: 'Telegram', link: 'https://t.me/functionx' },
      {
        icon: 'youtube',
        name: 'YouTube',
        link: 'https://www.youtube.com/channel/UCmS83bWNR43jwEOC6EJaOyw'
      },
      { icon: 'medium', name: 'Medium', link: 'https://medium.com/functionx' },
      {
        icon: 'facebook',
        name: 'Facebook',
        link: 'https://facebook.com/FunctionX.io/'
      },
      {
        icon: 'twitter',
        name: 'Twitter',
        link: 'http://twitter.com/functionx_io'
      },
      {
        icon: 'discord',
        name: 'Discord',
        link: 'https://discord.com/invite/J6k8arnyEQ'
      },
      { icon: 'github', name: 'Github', link: 'https://github.com/functionx' },
      { icon: 'email', name: 'Email', link: 'mailto:contact@functionx.io' }
      // { icon: 'rss', name: 'RSS', link: '' },
      // { icon: 'web', name: 'Web', link: 'https://functionx.io/' }
    ]
  },
  mutations: {
    setWallet(state, payload) {
      state.wallet = payload
    }
  },
  actions: {},
  modules: {}
})
